import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";

function InfoDialog(props) {
  const { onClose, open, content } = props;
  const handleClose = () => {
    onClose();
  };
  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Instructions</DialogTitle>
      <DialogContent>
        <Typography style={{ whiteSpace: "pre-line" }}>{content}</Typography>
      </DialogContent>
    </Dialog>
  );
}

InfoDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
};

export default InfoDialog;
